import { render } from "./PortalTopbar.vue?vue&type=template&id=a16244a8"
import script from "./PortalTopbar.vue?vue&type=script&lang=js"
export * from "./PortalTopbar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__